<div class="formEditorContainer">
<div class="control-buttons">
	<button class="control-button save" mat-flat-button (click)="submit()">Save</button>
</div>
<mat-form [formGroup]="form" (ngSubmit)="submit()">
	<mat-form-field appearance="outline" class="short">
		<mat-label>Name</mat-label>
		<input matInput formControlName="name" required>
	</mat-form-field>
	<mat-checkbox [checked]="true" formControlName="enabled">Enabled</mat-checkbox>
	<mat-checkbox [checked]="true" formControlName="trialAccount">Trial Account</mat-checkbox>
	<mat-checkbox [checked]="true" formControlName="aiEnabled">AI Enabled</mat-checkbox>
	<mat-form-field appearance="outline">
		<mat-label>Survey Categories</mat-label>
		<textarea matInput formControlName="surveyCategories"></textarea>
	</mat-form-field>
	<mat-form-field appearance="outline">
		<mat-label>AI Settings</mat-label>
		<textarea matInput formControlName="aiSettings"></textarea>
	</mat-form-field>
	<mat-form-field appearance="outline" class="number">
		<mat-label>Days from Appt.</mat-label>
		<input matInput style="width: 50px" type="number" min="1" formControlName="daysFromAppt" required>
	</mat-form-field><br/>
	<mat-form-field appearance="outline" class="short">
		<mat-label>Time Zone</mat-label>
		<input matInput formControlName="timeZone" required>
	</mat-form-field>
</mat-form>
</div>

